export const readHTMLFile = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (file.type !== 'text/html') {
      reject(new Error('Please upload an HTML file'));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      resolve(content);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};

export const isHTMLFile = (file: File): boolean => {
  return file.type === 'text/html' || file.name.endsWith('.html') || file.name.endsWith('.htm');
};
